module.exports = __webpack_public_path__ + "static/img/img15.b950821.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img15.jpg
// module id = zs2E
// module chunks = 1